import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import SearchResultsPage from './pages/SearchResultsPage';
import PropertyDetailsPage from './pages/PropertyDetailsPage';
import BookingPage from './pages/BookingPage';
import AuthPage from './pages/AuthPage';
import UserDashboardPage from './pages/UserDashboardPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import { AuthProvider } from './context/AuthContext';
import { BookingProvider } from './context/BookingContext';
export function App() {
  return <Router data-id="element-0">
      <AuthProvider data-id="element-1">
        <BookingProvider data-id="element-2">
          <div className="flex flex-col min-h-screen bg-[#F8F5F0]" data-id="element-3">
            <Routes data-id="element-4">
              <Route path="/admin/*" element={<AdminDashboardPage data-id="element-6" />} data-id="element-5" />
              <Route path="*" element={<>
                    <Header data-id="element-8" />
                    <main className="flex-grow" data-id="element-9">
                      <Routes data-id="element-10">
                        <Route path="/" element={<HomePage data-id="element-12" />} data-id="element-11" />
                        <Route path="/search" element={<SearchResultsPage data-id="element-14" />} data-id="element-13" />
                        <Route path="/property/:id" element={<PropertyDetailsPage data-id="element-16" />} data-id="element-15" />
                        <Route path="/booking/:id" element={<BookingPage data-id="element-18" />} data-id="element-17" />
                        <Route path="/auth" element={<AuthPage data-id="element-20" />} data-id="element-19" />
                        <Route path="/dashboard" element={<UserDashboardPage data-id="element-22" />} data-id="element-21" />
                      </Routes>
                    </main>
                    <Footer data-id="element-23" />
                  </>} data-id="element-7" />
            </Routes>
          </div>
        </BookingProvider>
      </AuthProvider>
    </Router>;
}